// extracted by mini-css-extract-plugin
export var content = "Content-module--content--3dNJJ";
export var content__title = "Content-module--content__title--2bVSe";
export var content__body = "Content-module--content__body--1YAIr";